// Use dynamic import to avoid eager consumption of shared modules
import("./bootstrap");
